import { IOfferState } from '../../../types/reducers/offer';
import { IMobileGetContextResponse } from '../../../repositories/monolith-python/v1/mobile-get-context';
import { TGetOfferDataResult } from '../types';

export const mapResponse200 = (response: IMobileGetContextResponse): TGetOfferDataResult => {
  const { offer } = response.data;

  /** TODO: нужен маппинг данных */
  return (offer as unknown as IOfferState) || null;
};
